/*
 * ambra-cta.js — Manejador ÚNICO para todos los CTA de las páginas AMBRA.
 *
 * Cualquier elemento con [data-apr-scroll] abre el modal de la app COD
 * (EasySell / ReleasIt) haciendo scroll al botón real y disparando un
 * clic completo sobre él.
 *
 * IMPORTANTE: espera a que la app COD esté realmente inicializada antes
 * de disparar. Sin esto, un CTA tocado muy arriba de la página abre el
 * modal antes de que la app pueda resolver la oferta de cantidad, y el
 * modal se queda cargando.
 */
(function(){
  if (window.__ambraCtaListo) return;
  window.__ambraCtaListo = true;

  var TEXTOS = [
    'pago contra entrega','pagar contra entrega','contra entrega',
    'contraentrega','comprar ahora','finalizar compra','ordenar ahora'
  ];

  function norm(t){
    return (t||'').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/\s+/g,' ').trim();
  }

  function visible(el){
    if(!el) return false;
    if(el.offsetParent === null) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function botonCompra(){
    var marcado = document.querySelector('[data-apr-cod]');
    if (visible(marcado)) return marcado;

    var els = document.querySelectorAll('button, a, [role="button"], [class*="btn"], [class*="button"]');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el.closest('[data-apr-scroll]')) continue;
      if (el.closest('.tkbar')) continue;
      if (el.querySelector('button, a')) continue;
      if (!visible(el)) continue;
      var t = norm(el.textContent);
      if (t.length > 70) continue;
      for (var j=0;j<TEXTOS.length;j++){
        if (t.indexOf(TEXTOS[j]) !== -1) return el;
      }
    }

    var alternos = [
      '#_rsi-buy-now-button',
      '[id*="easysell"] button',
      '[class*="easysell"] button',
      '.product-form__submit',
      'button[name="add"]',
      'product-form button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]'
    ];
    for (var k=0;k<alternos.length;k++){
      var c = document.querySelector(alternos[k]);
      if (visible(c)) return c;
    }
    if (marcado) return marcado;
    return null;
  }

  /* ¿La app COD ya está inicializada?
     Se considera lista cuando el botón propio de la app existe en el DOM
     (no el nativo del tema) o cuando la app expuso su objeto global. */
  function appLista(){
    if (window.EasySell || window.easysell || window.ReleasitCOD || window._rsi) return true;
    if (document.querySelector('#_rsi-buy-now-button')) return true;
    if (document.querySelector('[id*="easysell"], [class*="easysell"]')) return true;
    if (document.querySelector('[data-apr-cod]')) return true;
    var el = botonCompra();
    if (!el) return false;
    var t = norm(el.textContent);
    for (var i=0;i<TEXTOS.length;i++){ if (t.indexOf(TEXTOS[i]) !== -1) return true; }
    return false;
  }

  function clicReal(el){
    ['pointerdown','mousedown','pointerup','mouseup','click'].forEach(function(tipo){
      var ev;
      try { ev = new MouseEvent(tipo,{bubbles:true,cancelable:true,view:window}); }
      catch(err){ ev = document.createEvent('MouseEvents'); ev.initEvent(tipo,true,true); }
      el.dispatchEvent(ev);
    });
    if (typeof el.click === 'function'){ try { el.click(); } catch(e){} }
  }

  var abriendo = false;

  /* Espera a que la app esté lista (hasta 3 s) y solo entonces dispara. */
  function esperarYAbrir(intento){
    var el = botonCompra();

    if (el && intento === 0){
      try { el.scrollIntoView({behavior:'smooth', block:'center'}); } catch(e){ el.scrollIntoView(); }
    }

    if (el && appLista()){
      setTimeout(function(){
        clicReal(el);
        setTimeout(function(){ abriendo = false; }, 700);
      }, intento === 0 ? 340 : 120);
      return;
    }

    if (intento < 20){                       /* 20 x 150ms = 3 s */
      setTimeout(function(){ esperarYAbrir(intento+1); }, 150);
      return;
    }

    /* Se acabó la espera: disparamos igual con lo que haya. */
    if (el){
      clicReal(el);
      setTimeout(function(){ abriendo = false; }, 700);
      return;
    }

    var f = document.querySelector('.product-form')
         || document.querySelector('.price')
         || document.querySelector('#MainContent');
    if (f) f.scrollIntoView({behavior:'smooth', block:'center'});
    abriendo = false;
  }

  document.addEventListener('click', function(e){
    var disparador = e.target.closest && e.target.closest('[data-apr-scroll]');
    if (!disparador) return;
    e.preventDefault();
    e.stopPropagation();
    if (abriendo) return;
    abriendo = true;
    esperarYAbrir(0);
  }, true);

  /* Precalentado: en cuanto la app esté lista, marcamos su boton para que
     las búsquedas posteriores sean inmediatas. */
  var pre = 0;
  var ivPre = setInterval(function(){
    if (appLista()){
      var b = botonCompra();
      if (b && !b.hasAttribute('data-apr-cod')) b.setAttribute('data-apr-cod','1');
      clearInterval(ivPre);
    }
    if (++pre > 60) clearInterval(ivPre);
  }, 250);

})();
